module.exports = __webpack_public_path__ + "static/media/Chris Mottla.9560ff3e.png";